declare let BUILD_VERSION: string;
declare let BUILD_COMMIT: string;
declare let BUILD_TYPE: string;
declare let TARGET_ENVIRONMENT: string;

/** Defines environment configuration settings */
interface ConfigurationObject {

    /** The version of the build */
    BuildVersion: string;

    /** The commit that this build was generated from */
    BuildCommit: string;

    /** The type of build that is running */
    BuildType: string;

}

/**
 * Creates a configuration object based on the environment settings
 * @returns A configuration object.
 */
function buildConfigurationObject(): ConfigurationObject {

    // tslint:disable:max-line-length
    let config: ConfigurationObject = {
        BuildVersion: BUILD_VERSION,
        BuildCommit: BUILD_COMMIT,
        BuildType: BUILD_TYPE,
    };
    // tslint:enable:max-line-length

    return config;
}

/** The application's current configuration */
export let Config: ConfigurationObject = buildConfigurationObject();
